import { Column, Entity, JoinColumn, ManyToOne, OneToMany, OneToOne } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { QuestionPage } from "./question-page.entity";
import { Shop } from "./shop.entity";
import { ShopToken } from "./shop-token.entity";

@Entity()
export class QuestionHeader extends CommonColumns {

  @ManyToOne(() => Shop, shop => shop.questionHeaders, { nullable: false, })
  @JoinColumn({ name: 'shop_id', referencedColumnName: 'id', })
  shop: Shop;

  @Column({ name: 'shop_id', })
  shopId: number;

  @Column()
  name: string;

  @OneToMany(() => ShopToken, shopToken => shopToken.questionHeader)
  shopTokens: ShopToken[];

  @OneToMany(() => QuestionPage, questionPage => questionPage.questionHeader)
  questionPages: QuestionPage[];

  constructor(props: TQuestionHeader) {
    super();
    Object.assign(this, props);
  }
}

export declare type TQuestionHeader = Omit<QuestionHeader, 'dummy-no-such-field'>;
export interface IQuestionHeader extends TQuestionHeader {};
